import { createSelector } from 'reselect';
import { FileUploadsState } from './reducer';

const selectFileUploadsState = (state: any): FileUploadsState => state.gosStrapi?.fileUploads || { files: [], loading: false, error: null };

export const selectAllFiles = createSelector([selectFileUploadsState], (fileUploadsState) => fileUploadsState.files);

export const selectFilesByPrescID = (prescID: number) =>
  createSelector([selectAllFiles], (files) => files.filter((file) => file.prescID === prescID));

export const selectFilesByLicenseID = (licensesID: number) =>
  createSelector([selectAllFiles], (files) => files.filter((file) => file.licensesID === licensesID));

export const selectFilesLoading = createSelector([selectFileUploadsState], (fileUploadsState) => fileUploadsState.loading);

export const selectFilesError = createSelector([selectFileUploadsState], (fileUploadsState) => fileUploadsState.error);

export const selectFilesCount = createSelector([selectAllFiles], (files) => files.length);

export const selectFilesCountByPrescID = (prescID: number) =>
  createSelector([selectFilesByPrescID(prescID)], (files) => files.length);

export const selectFilesCountByLicenseID = (licensesID: number) =>
  createSelector([selectFilesByLicenseID(licensesID)], (files) => files.length);

export const selectHasUploadingFiles = createSelector([selectAllFiles], (files) => files.some((file) => file.isUploading));
